import * as React from 'react';

function SvgMailUnreadOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M5.054 7.577l6.872 5.345 4.152-3.134" }),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M13.62 4.442H3.93A1.929 1.929 0 002 6.372v11.573a1.929 1.929 0 001.929 1.93h16.142A1.929 1.929 0 0022 17.944v-6.607" }),
        React.createElement("circle", { cx: 19.05, cy: 6.05, r: 2.25, stroke: "currentColor", strokeWidth: 1.6 }),
        React.createElement("circle", { cx: 19.05, cy: 6.05, r: 3.05, fill: "currentColor" })));
}

export default SvgMailUnreadOutline;
